import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const ChatBubbleStyles = styled(Box)(({ theme, isBot,error }) => ({
  "&.bubble": {
    height: 'fit-content',
    maxHeight: 'fit-content',
    maxWidth: '90%',
    width: 'fit-content',
    padding: theme.spacing(0.5), // Equivalent to 4px
    marginBottom: theme.spacing(1), // Equivalent to 8px
    display: 'flex',
    flexDirection: 'column',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    backgroundColor: error
        ? theme.palette.error.light
        : isBot
            ? theme.palette.datagrid.main
            : theme.palette.primary.main,
    alignSelf: isBot ? 'flex-start' : 'flex-end',
    marginLeft: isBot ? theme.spacing(4) : '0px', // Equivalent to 32px
    marginTop: theme.spacing(0.5), // Equivalent to 4px
    color: error
        ? theme.palette.error.contrastText
        : isBot
            ? theme.palette.primary.dark
            : theme.palette.common.white,
    marginRight: isBot ? '0px' : theme.spacing(0.625), // Equivalent to 5px
    borderRadius: isBot ? '0 24px 24px 24px' : '16px 0 16px 16px', // Border radius remains as is
    border: error ? `1px solid ${theme.palette.error.dark}` : "none",

  },
  "& .repliedText": {
  backgroundColor: theme.palette.grey[200],
  borderLeft: `3px solid ${theme.palette.grey[500]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.75, 1), // 6px vertical, 8px horizontal
  marginBottom: theme.spacing(0.75), // Space below the reply
  color: theme.palette.text.secondary,
  fontSize: theme.typography.pxToRem(13),
  fontStyle: 'italic',
  maxWidth: '100%',
  wordBreak: 'break-word',
  overflowWrap: 'anywhere',
},
  "& .bubbleText": {
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    marginBottom: theme.spacing(0.5), // Equivalent to 4px
    paddingRight: theme.spacing(1), // Equivalent to 8px
    paddingLeft: theme.spacing(1), // Equivalent to 8px
    paddingTop:0,
    paddingBottom:0,

  },
  "& .loadingText": {
    marginRight: theme.spacing(0.5), // Equivalent to 4px
    fontSize: theme.typography.pxToRem(12), // This remains in px
    color: theme.palette.common.white, // Replaced #8a8a8a
    fontStyle: 'italic',
  },
  "& .loadingMessage": {
    display: 'flex',
  },
  '& .chatBubbleTable': {
    maxWidth: '100%', // Full width of the bubble
    width: '5000px', // Full width of the bubble
    height: '70%',
    overflowX: 'auto', // Allow scrolling if content overflows
    overflowY: 'hidden', // Allow scrolling if content
    flexGrow: 1, // Allows the table to grow within the chat bubble
  },
  "& .LoadingComponent":{

    paddingTop: theme.spacing(0.25),

  },
  "& .markDownPreviewWrapper": {
    height: '100%',
    padding: theme.spacing(0),
    backgroundColor: isBot ? theme.palette.datagrid.main : theme.palette.primary.dark,
    margin: 0,

    // Targeting <code> elements within .markDownPreviewWrapper
    "& code": {
      overflowX: 'auto',
      maxWidth: '100%',
      display: 'block', // Ensures block-level display for <code>
      backgroundColor: theme.palette.datagrid.odd, // Optional: Background color for code blocks
      padding: theme.spacing(1), // Optional: Padding for code blocks
      borderRadius: theme.shape.borderRadius, // Optional: Rounded corners
      margin:0,
    },
    "& p": {
      margin: 0, // Overrides the default margins for <p> elements
    },
  },
}));

export default ChatBubbleStyles;
